import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-copy-link-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M2.72483 10C2.0665 9.20833 1.6665 8.19167 1.6665 7.08333C1.6665 4.56667 3.72484 2.5 6.24984 2.5H10.4165C12.9332 2.5 14.9998 4.56667 14.9998 7.08333C14.9998 9.6 12.9415 11.6667 10.4165 11.6667H8.33317"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M17.275 10.0002C17.9333 10.7918 18.3333 11.8085 18.3333 12.9168C18.3333 15.4335 16.275 17.5002 13.75 17.5002H9.58333C7.06667 17.5002 5 15.4335 5 12.9168C5 10.4002 7.05833 8.3335 9.58333 8.3335H11.6667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class CopyLinkIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
